import type { FlowTask } from '@Types/FlowTask.interface';
import { RequestFlowType } from '@Enums/requestFlowType.enum';
import { RequestType } from '@Enums/requestType.enum';


/**
 * Display definitions for backend-driven WhatsNext tiles, keyed by RequestFlowType.
 * Only flow types listed here will appear as tiles on the WhatsNext page.
 * Order is determined by the backend (requiredFlows).
 */
export const WHATS_NEXT_FLOW_TILES: Partial<Record<RequestFlowType, Partial<FlowTask>>> = {
    // Send
    [RequestFlowType.MppTransferAmount]: {
        displayName: 'Choose additional protection',
        icon: 'cd-ic-money-shield',
        moreInfo: 'You\'ll have the chance to purchase an optional Money Protection Plan.',
    },
    [RequestFlowType.HeroPackage]: {
        displayName: 'Review money protection plan',
        icon: 'cd-ic-money-shield',
        moreInfo: 'We\'ll review the coverage {{companyName}} has included to protect your closing.',
    },
    [RequestFlowType.WireInstructionsReady]: {
        displayName: 'Download wire instructions',
        icon: 'cd-ic-paper-download',
        moreInfo: 'This packet contains the details you need to complete your transaction.',
    },
    [RequestFlowType.WireInstructions]: {
        displayName: 'Download wire instructions',
        icon: 'cd-ic-paper-download',
    },
    // Confirm
    [RequestFlowType.ClientHubConfirmComplete]: {
        displayName: 'Confirm bank details',
        icon: 'cd-ic-bank',
        moreInfo: 'You will need to confirm your bank account information.',
    },
    [RequestFlowType.ClientHubConfirmReview]: {
        displayName: 'Confirm bank details',
        icon: 'cd-ic-bank',
        moreInfo: 'You will need to confirm your bank account information.',
    },
    // Collect
    [RequestFlowType.ClientHubCollectAccountDetails]: {
        displayName: 'Submit bank details',
        icon: 'cd-ic-bank',
        moreInfo: 'You\'ll need the bank account details for this closing, so get them ready before you start.',
    },
    // MATCH - uses only prepend tiles for RequestType.Identity below. No tiles connected to flows steps.
};

/**
 * Frontend-only tiles prepended to the WhatsNext list, keyed by RequestType.
 * These have no associated route and do not affect navigation.
 * Supports a single tile or an array of tiles per request type.
 */
export const WHATS_NEXT_PREPEND_TILES: Partial<Record<RequestType, Partial<FlowTask> | Partial<FlowTask>[]>> = {
    [RequestType.Send]: {
        displayName: 'Validate your device',
        icon: 'cd-ic-mobile',
        moreInfo: 'We will use multi-factor authentication to make sure you\'re on a trusted device.',
    },
    [RequestType.Collect]: {
        displayName: 'Verify your identity',
        icon: 'cd-ic-scan',
        moreInfo: 'We will ask a few security questions to help us verify your identity.',
    },
    [RequestType.Confirm]: {
        displayName: 'Verify your identity',
        icon: 'cd-ic-scan',
        moreInfo: 'We will ask a few security questions to help us verify your identity.',
    },
    [RequestType.Identity]: [
        {
            displayName: 'Scan valid ID',
            icon: 'cd-ic-scan',
            moreInfo: 'You\'ll need to scan a valid ID, like your driver\'s license or passport \u2013 so grab this before you start.',
        },
        {
            displayName: 'Take a photo',
            icon: 'cd-ic-photo-camera',
            moreInfo: 'You\'ll need to take a photo of your face with your device. Make sure you have good lighting.',
        },
    ]
};
